export default function(text, replace = {}) {
    let line = text
    let keys = Object.keys(replace)
    keys = keys.sort().reverse()
    keys.forEach((key) => {
        line = line.replace(':' + key, replace[key])
    })
    return line
}

